import type { Theme } from '../types';
import type { Components } from '@mui/material/styles';

export const MuiMenu = {
  defaultProps: { disableScrollLock: true },
  styleOverrides: { list: { display: 'flex', flexDirection: 'column' } },
} satisfies Components<Theme>['MuiMenu'];
